module.exports = {
    RECEIVE_LANDMARKS_PRODUCTION_MODE: 'RECEIVE_LANDMARKS_PRODUCTION_MODE',
}
